<div class="container">
    <ai-panel>
        <ai-panel-header>
            <div class="ai-crud-header-title">
                <div style="display: flex; align-items: center; gap: 15px">
                    <ai-icon [fontIcon]="titleIcon()"></ai-icon>
                    <h1>{{ title() }}</h1>
                </div>
                <div *ngIf="isNetworkActive()" class="ai-crud-loading"></div>
            </div>
        </ai-panel-header>
        <ai-breadcrumbs [items]="breadcrumbItems()"></ai-breadcrumbs>
        <ai-panel-content>
            <ng-content select="ai-crud-header"></ng-content>

            <form [formGroup]="formGroup()" (ngSubmit)="onSubmitForm($event)">
                <ng-content></ng-content>

                <div
                    class="ai-crud-actions"
                    [class.ai-crud-actions--floating]="isActionsFloating()"
                >
                    <div class="ai-crud-actions-bar">
                        <span class="ai-crud-actions-left">
                            <ai-button
                                [label]="submitLabel()"
                                [variant]="'primary'"
                                [disabled]="
                                    !formGroup().valid &&
                                    this.formGroup().disabled
                                "
                                [type]="'submit'"
                                [shape]="'base-rounder'"
                                [tooltip]="submitLabel()"
                            >
                                @if (isNetworkActive()) {
                                    <ai-icon
                                        [imageIcon]="
                                            '/assets/images/icons/tube-spinner.svg'
                                        "
                                    />
                                } @else {
                                    <ai-icon [fontIcon]="submitIcon()" />
                                }
                            </ai-button>
                            <ai-button
                                [label]="formGroup().dirty ? cancelLabel() : backLabel()"
                                [type]="'button'"
                                [variant]="formGroup().dirty ? 'danger' : 'default'"
                                [disabled]="this.formGroup().disabled"
                                (click)="onCancelClick()"
                                [shape]="'base-rounder'"
                                [tooltip]="formGroup().dirty ? cancelLabel() : backLabel()"
                            >
                                <ai-icon
                                    [fontIcon]="
                                        formGroup().dirty
                                            ? 'fa-solid fa-xmark'
                                            : 'fa-solid fa-arrow-left'
                                    "
                                />
                            </ai-button>
                            @if (formGroup().dirty) {
                                <span class="ai-crud-unsaved">
                                    <span class="ai-crud-unsaved-dot"></span>
                                    {{ unsavedLabel() }}
                                </span>
                            } @else {
                                <span class="ai-crud-saved">
                                    <ai-icon
                                        [fontIcon]="'fa-solid fa-circle-check'"
                                    />
                                    {{ savedLabel() }}
                                </span>
                            }
                        </span>
                        <div class="ai-crud-required-fields">
                            <ai-icon [fontIcon]="'red_rectangle_icon'" />
                            <span class="ai-crud-required-fields-message"
                                ><i>Campos Obrigatórios</i></span
                            >
                        </div>
                    </div>
                </div>
                <div #actionsSentinel class="ai-crud-actions-sentinel"></div>
            </form>
        </ai-panel-content>
    </ai-panel>
</div>
